<template lang="pug">
  .coach-dance-kinds
    span(v-for="(danceKind, index) in coach.localeSupportedDanceKinds"
      :key="index") {{ danceKind }}
</template>

<style lang="scss" scoped>
.coach-dance-kinds {
  text-align: center;
  @extend %round-rect-text;

  span {
    display: inline-block;
    line-height: 28px;
    padding: 0 12px;
    border-radius: 14px;
    background: rgba(0, 0, 0, 0.4);
    margin-bottom: 8px;
  }
  span:nth-child(even) {
    margin: 0 8px;
  }
}
</style>

<script>
export default {
  props: {
    coach: {
      type: Object,
      required: true,
    },
  },
}
</script>
